import { Box } from '@mui/system'
import React, { useCallback, useState } from 'react'

export type TabPanelProps = {
	id: string
	ariaLabelledby: string
}

type TabPanels = Record<string, TabPanelProps>

type TabPanelContextT = {
	tabPanels: TabPanels
	setTabPanelProps: (tabsId: string, tabPanelProps: TabPanelProps) => void
}

export const TabPanelContext = React.createContext<TabPanelContextT>({ tabPanels: {}, setTabPanelProps: () => {} })

export function TabPanel({ id, children }: { id: string; children: React.ReactNode }) {
	const {
		tabPanels: { [id]: tabPanel },
	} = React.useContext(TabPanelContext)

	if (!tabPanel) {
		return children
	}

	return (
		<Box role="tabpanel" id={tabPanel.id} aria-labelledby={tabPanel.ariaLabelledby}>
			{children}
		</Box>
	)
}

export function TabPanelContextProvider({ children }: { children: React.ReactNode }) {
	const [tabPanels, setTabPanels] = useState<TabPanels>({})

	const setTabPanelProps = useCallback<TabPanelContextT['setTabPanelProps']>(
		(tabsId, tabPanelProps) =>
			setTabPanels((tabPanels) => ({
				...tabPanels,
				[tabsId]: tabPanelProps,
			})),
		[],
	)

	return <TabPanelContext.Provider value={{ tabPanels, setTabPanelProps }}>{children}</TabPanelContext.Provider>
}
